import './StatisticPage.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useApplyFilters } from "../../hooks/useApplyFilters";

import { openDrawer } from "../../slices/drawerSlice";

import FilterAlt from "@mui/icons-material/FilterAlt";
import AutoAwesome from "@mui/icons-material/AutoAwesome";

import { Box } from "@mui/material";

import { TextButton } from "../../common-components/Buttons/Buttons";
import { AiTextButton } from "../../common-components/AiTextButton/AiTextButton";

import TotalCard from "../../components/TotalCard/TotalCard";
import ClosedCard from "../../components/ClosedCard/ClosedCard";
import WorkersCard from "../../components/WorkersCard/WorkersCard";
import HoursCard from "../../components/HoursCard/HoursCard";
import AccidentStatistic from "../../components/AccidentStatistic/AccidentStatistic";
import BranchStatistic from "../../components/BranchStatistic/BranchStatistic";
import InjuryStatistic from "../../components/InjuryStatistic/InjuryStatistic";
import EvacuatedStatistic from "../../components/EvacuatedStatistic/EvacuatedStatistic";
import ResponseStatistic from "../../components/ResponseStatistic/ResponseStatistic";
import HoursStatistic from "../../components/HoursStatistic/HoursStatistic";
import TransportStatistic from "../../components/TransportStatistic/TransportStatistic";
import DeparturesFilters from "../../departures/DeparturesFilters/DeparturesFilters";
import AiReport from "../../departures/components/AiReport/AiReport";
import DeparturesFiltersTools
    from "../../departures/DeparturesFilters/components/DeparturesFiltersTools/DeparturesFiltersTools";
import DeparturesFiltersFooter
    from "../../departures/DeparturesFilters/components/DeparturesFiltersFooter/DeparturesFiltersFooter";

const StatisticPage = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.user.data);
    const permissions = data?.relationships?.role?.permissions || [];
    const params = useApplyFilters({componentId: "departures"});

    const hasPermission = permissions.some(
        (permission) => permission.name === "departure_view"
    );

    const handleOpenDrawer = () => {
        dispatch(openDrawer({content: <DeparturesFilters/>, tools: <DeparturesFiltersTools/>, footer: <DeparturesFiltersFooter/>}))
    }

    const handleOpenAiDrawer = () => {
        dispatch(
            openDrawer({
                content: <AiReport />
            })
        );
    };

    return (
        <Box className={"statistic_page"}>
            <Box className={"statistic_page_container"}>
                <Box className={"statistic_page_container_tools"}>
                    <TextButton Icon={FilterAlt} title={"Фильтры"} onClick={handleOpenDrawer} active={true}/>
                    <AiTextButton
                        Icon={AutoAwesome}
                        title={"AI аналитика"}
                        onClick={handleOpenAiDrawer}
                    />
                </Box>
                <Box className={"statistic_page_container_cards"}>
                    <TotalCard params={params.params}/>
                    <ClosedCard params={params.params}/>
                    <WorkersCard params={params.params}/>
                    <HoursCard params={params.params}/>
                </Box>
                <Box className={"statistic_page_container_charts"}>
                    <AccidentStatistic params={params.params}/>
                    <TransportStatistic params={params.params}/>
                    <InjuryStatistic params={params.params}/>
                    <EvacuatedStatistic params={params.params}/>
                    <ResponseStatistic params={params.params}/>
                    <HoursStatistic params={params.params}/>
                    { hasPermission && (
                        <BranchStatistic params={params.params}/>
                    )}
                </Box>
            </Box>
        </Box>
    )
}


export default StatisticPage;





















































































































































